import Vue from 'vue';
import VueI18n from 'vue-i18n';
import merge from 'lodash/merge';
import cloneDeep from 'lodash/cloneDeep';

import { BRAND_FEATURES, hasBrandFeature, getUserBrandCode } from './constants/organisation';
import baseHy from './locales/hy.json';
import ru from './locales/ru.json';
import en from './locales/en.json';

Vue.use(VueI18n);

export function getCachedUserBrandCode() {
  try {
    const me = JSON.parse(localStorage.getItem('me') || '{}');
    return getUserBrandCode(me);
  } catch (e) {
    return null;
  }
}

export function getBrandLocale(brandCode, lang = 'hy') {
  if (!brandCode) return null;
  try {
    const brand = String(brandCode).trim().toLowerCase();
    return require(`./locales/brands/${brand}/${lang}.json`);
  } catch (e) {
    return null;
  }
}

export function getHyMessages(brandCode) {
  const code = arguments.length > 0 ? brandCode : getCachedUserBrandCode();
  if (hasBrandFeature(BRAND_FEATURES.BRAND_LOCALES, code)) {
    const brandHy = getBrandLocale(code, 'hy');
    if (brandHy) {
      return merge(cloneDeep(baseHy), brandHy);
    }
  }
  return cloneDeep(baseHy);
}

const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'hy',
  messages: {
    hy: getHyMessages(),
    ru,
    en,
  },
});

export function applyBrandLocale(brandCode) {
  i18n.setLocaleMessage('hy', getHyMessages(brandCode));
}

export default i18n;
